import { useContext, useEffect, useState } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { loadJson } from '../utils/loadJson'; // Importa la función de carga de JSON



const Contact = () => {
    const { language } = useContext(LanguageContext);
    const [translations, setTranslations] = useState({});

    useEffect(() => {
        // Cargar cada JSON de forma independiente y asignarlo a su variable
        const fetchTranslations = async () => {
            const data = await loadJson(`${process.env.PUBLIC_URL}/json/translations.json`);
            setTranslations(data);
        };

     

        fetchTranslations();
        
    }, []);

    const t = translations[language] || {};

    // const [formData, setFormData] = useState({
    //     name: '',
    //     email: '',
    //     message: ''
    // });

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     // Aquí iría la lógica para enviar el formulario
    //     console.log('Form submitted:', formData);
    // };

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setFormData(prev => ({
    //         ...prev,
    //         [name]: value
    //     }));
    // };

    return (
        <div className="wrapper">
        <p>
        <h2>{t.contact?.title}</h2>
        </p>
        <div className="cardContent">
            <div className="card_project_detail card_project_contact">
                
                <ul>
                    {t.contact?.links.map((item, index) => (
                        <li key={index}>

                            <li><a href={item.url} className="details-link">{item.text}</a></li>
                        </li>))}
                </ul>
                <hr />
            </div>
            </div>
        </div>
    );
};

export default Contact;